module.exports = __webpack_public_path__ + "static/media/AdobeStock_295693279_RED.ab16b4af.webp";